import { render, staticRenderFns } from "./editReceipt.vue?vue&type=template&id=356bfe54&scoped=true"
import script from "./editReceipt.vue?vue&type=script&lang=js"
export * from "./editReceipt.vue?vue&type=script&lang=js"
import style0 from "./editReceipt.vue?vue&type=style&index=0&id=356bfe54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356bfe54",
  null
  
)

export default component.exports